// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { buttonTransparent } from "@electrowire/XDL/PreStyle/button";
import colors from "@gcg/XDL/PreStyle/colors";
import { xBaseTheme } from "@gcg/XDL/types";
import ToastPresentationPropsDefault, {
    toasterProps as toasterPropsDefault,
} from "@insite/mobius/Toast/presentationProps";
import { get } from "@insite/mobius/utilities";
import { css, ThemeProps } from "styled-components";

const iconColor = get(colors, "common.border");

export default {
    defaultProps: {
        ...ToastPresentationPropsDefault,
        cssOverrides: {
            toast: css`
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                border-left-width: 5px;
            `,
            toastBody: css`
                margin: 12px 16px 12px 20px !important;
            `,
        },
        iconProps: {
            css: css`
                display: none;
            `,
        },
        bodyTypographyProps: {},
        closeButtonProps: {
            color: "transparent",
            css: css`
                padding-left: 5px;
                padding-right: 5px;
                margin-right: 2px;
                margin-top: 8px;
                ${buttonTransparent}
            `,
        },
        closeButtonIconProps: {
            color: iconColor,
            css: css`
                width: 20px;
                height: 20px;
            `,
        },
        iconSrcByMessage: {},
    },
    toasterProps: { toasterPropsDefault },
} as xBaseTheme["toast"];
